import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { GetAndCreateAssignedToMails } from '../../../../services/ProductService/AddProducts/AddProducts';
import { BulkAssignedto } from '../../../../services/ProductService/AllProductList/AllProductServices';

export default function BulkAssignedTo({ onSelectedIds, onSuccess }) {
    const [assignedEmail, setAssignedEmail] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [message, setMessage] = useState('');

    const [assignment, setAssignment] = useState({
        p_ids: [],
        admin_emails: [],
        completed_on: '',
        priority: '',
        comments: '',
    });

    const openPopup = () => setShowPopup(true);
    const closePopup = () => setShowPopup(false);

    // Fetch emails
    const fetchAssignedEmails = async () => {
        try {
            const response = await GetAndCreateAssignedToMails('GET', {});
            setAssignedEmail(response.data);
            console.log(response.data);
        } catch (error) {
            console.error('Error fetching emails:', error);
        }
    };

    useEffect(() => {
        fetchAssignedEmails();
    }, []);

    // Handle selecting an email
    const handleSelectEmail = (email) => {
        if (!assignment.admin_emails.includes(email)) {
            setAssignment((prev) => ({
                ...prev,
                admin_emails: [...prev.admin_emails, email],
            }));
        }
        setInputValue('');
        setShowSuggestions(false);
    };

    // Handle removing an email
    const handleRemoveEmail = (email) => {
        setAssignment((prev) => ({
            ...prev,
            admin_emails: prev.admin_emails.filter((item) => item !== email),
        }));
    };

    // Handle input changes
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        setShowSuggestions(true);
    };

    // Show suggestions on focus
    const handleInputFocus = () => {
        setShowSuggestions(true);
    };

    // Update `product_ids` when `onSelectedIds` changes
    useEffect(() => {
        if (onSelectedIds?.length > 0) {
            setAssignment((prev) => ({
                ...prev,
                p_ids: onSelectedIds
            }));
        }
    }, [onSelectedIds]);

    useEffect(() => {
        // Close suggestions when clicking outside
        const handleClickOutside = (e) => {
            if (!e.target.closest('.suggestion-container')) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onSelectedIds]);

    // Handle Assign Action
    const handleAssign = async () => {
        const { p_ids = [], admin_emails = [], priority, comments } = assignment;

        // Validation check (excluding assigned_to_me)
        if (
            p_ids.length === 0 ||
            admin_emails.length === 0 ||
            !priority ||
            !comments
        ) {
            setMessage('Please fill in all fields before assigning.');
            return;
        }

        try {
            const response = await BulkAssignedto('POST', {"assignment":assignment});
            closePopup();
            setMessage('');
            onSuccess()
        } catch (error) {
            console.error('Error in BulkAssignedTo:', error);
            setMessage('An error occurred while assigning.');
        }
    };

    return (
        <div>
            {/* Trigger to open modal */}
            <div className="flex flex-col">
                <label htmlFor="assignedTo" className="font-normal py-1 text-left px-3 hover:bg-gray-200"
                    onClick={openPopup}>
                    Assigned To
                </label>
            </div>

            {/* Popup */}
            <Modal
                isOpen={showPopup}
                onRequestClose={closePopup}
                className="bg-white p-6 rounded-lg shadow-lg w-fit mx-auto z-50  font-normal"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            >
                {/* Header */}
                <div className="border-b border-gray-400 mb-4">
                    <h2 className="text-xl font-semibold text-center">Assigned To</h2>
                </div>

                {/* Assigned to me checkbox */}
                <div className="flex items-center gap-3 mb-4">
                    <input
                        type="checkbox"
                        name="assigned_to_me"
                        checked={assignment.assigned_to_me}
                        onChange={(e) =>
                            setAssignment((prev) => ({
                                ...prev,
                                assigned_to_me: e.target.checked,
                            }))
                        }
                        className="scale-125"
                    />
                    <p>Assigned To me</p>
                </div>

                {/* Assign to */}
                <div>
                    <h1 className="text-gray-500 font-bold mb-2">
                        Assign To <span className="text-red-500">*</span>
                    </h1>
                    <div className="relative suggestion-container">
                        {/* Input with selected emails */}
                        <div className="flex items-center gap-2 border border-gray-300 rounded-md bg-blue-50 p-2 h-20 overflow-y-scroll whitespace-nowrap">
                            {assignment.admin_emails.map((email) => (
                                <div
                                    key={email}
                                    className="bg-blue-100 text-blue-700 px-2 py-1 rounded flex items-center"
                                >
                                    {email}
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveEmail(email)}
                                        className="ml-2 text-red-500 hover:text-red-700"
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                            <input
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                                placeholder="Enter assigned to"
                                className="outline-none bg-blue-50 flex-shrink-0 w-40"
                            />
                        </div>

                        {/* Suggestions */}
                        {showSuggestions && (
                            <div className="absolute z-10 bg-white border border-gray-300 w-full mt-1 rounded-md shadow-md max-h-40 overflow-y-auto">
                                {assignedEmail
                                    .filter((item) =>
                                        item.a_email.toLowerCase().includes(inputValue.toLowerCase())
                                    )
                                    .map((item) => (
                                        <div
                                            key={item.id}
                                            onClick={() => handleSelectEmail(item.a_email)}
                                            className="p-2 cursor-pointer hover:bg-blue-100"
                                        >
                                            {item.a_email}
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>

                </div>

                {/* Completed By & Priority */}
                <div className="flex items-center gap-5">
                    <div>
                        <h1 className="font-semibold mb-2 text-gray-500">Completed On</h1>
                        <input
                            type="date"
                            name="completed_on"
                            required
                            value={assignment.completed_on}
                            onChange={(e) =>
                                setAssignment((prev) => ({
                                    ...prev,
                                    completed_on: e.target.value,
                                }))
                            }
                            className="w-52 border border-gray-300 rounded-xl p-3 bg-blue-50 outline-none"
                        /> 
                    </div>
                    <div>
                        <h1 className="font-semibold mb-2 text-gray-500">Priority</h1>
                        <select
                            name="priority"
                            required
                            value={assignment.priority}
                            onChange={(e) =>
                                setAssignment((prev) => ({
                                    ...prev,
                                    priority: e.target.value,
                                }))
                            }
                            className="w-52 p-4 border border-gray-300 rounded-xl outline-none bg-blue-50 cursor-pointer"
                        >
                            <option value="">Select Priority</option>
                            <option value="Low" className="text-orange-600">Low</option>
                            <option value="Medium" className="text-green-600">Medium</option>
                            <option value="High" className="text-[#FF0000]">High</option>
                        </select>
                    </div>
                </div>

                {/* Comments */}
                <div>
                    <h1 className="font-bold text-gray-500">Comments</h1>
                    <textarea
                        name="comments"
                        required
                        value={assignment.comments}
                        onChange={(e) =>
                            setAssignment((prev) => ({
                                ...prev,
                                comments: e.target.value,
                            }))
                        }
                        placeholder="Write Comments..."
                        className="border border-gray-300 h-32 w-full my-2 rounded-xl bg-blue-50 p-2 outline-none"
                    />
                </div>

                <div>
                    <p className='text-[#FF0000]'>{message}</p>
                </div>
                {/* Action Buttons */}
                <div className="flex justify-end space-x-3 mt-4">
                    <button onClick={closePopup} className="px-4 py-2 border">
                        Cancel
                    </button>
                    <button onClick={handleAssign} className="px-4 py-2 bg-blue-500 text-white">
                        Assign
                    </button>
                </div>
            </Modal>
        </div>
    );
}